
let config = {
    root: window.wwwRoot || 'http://ThinkpadJurjen:7101/iloEval-App-context-root/',
    documentUrl: window.documentUrl || 'https://wwwex.ilo.org/ordsnpub/prdutf8p/eitrack/files/file/',
    excelServiceEndpoint: window.excelServiceEndpoint || 'https://www.ilo.org/excel-service/export',
    dcDashboardUrl: window.dcDashboardUrl || 'https://www.ilo.org/DevelopmentCooperationDashboard/',
    evaluationContext: '/ievaldiscovery/',
    data: {
        dimensionTitles: {


            'theme_category': 'Theme category',
            'theme': 'Evaluation theme(s)',
            'theme_combined': 'Evaluation Theme(s)',
            'year': 'Year',
            'doc_type': 'Evaluation document type',
            'eval_type': 'Evaluation type',
            'region': 'Region(s)',
            'country': 'Country(ies)',
            'subject_expertise_title': 'Subject expertise',
            'eval_timing': 'Evaluation timing',
            'eval_nature': 'Evaluation nature',
            'tc_symbol': 'Project symbol(s)',
            'eval_id': 'Evaluation number',
            'eval_number': 'Evaluation number',
            'll_id': 'Lessons learned ID',
            'gp_id': 'Good practices ID',
            'rec_id': 'Recommendation ID',
            'creation_date': 'Creation date',
            'sta_desc': 'STA description',
            'planned_completion_date': 'Planned completion date',
            'planned_start_date': 'Planned start date',
            'eval_manager': 'Evaluation manager(s)',
            'administrative_unit': 'Administrative unit(s)',
            'funding_source': 'Funding source(s)',
            'tech_unit': 'Technical unit(s)',
            'regional_project_countries': 'Regional project countries',
            'document_type': 'Document type',
            'planned_flag': 'Planned evaluation',
            'project_id': 'Project ID',
            'eval_title': 'Evaluation title',
            'll_desc': 'Lessons learned description',
            'gp_desc': 'Good practices description',
            'rec_desc': 'Recommendation description',
            'eval_rpt_end_year': 'Year',
            'document_id': 'Documents',
            'completion_date': 'Completion date',

            'll_challenges': 'Challenges', 
            'll_context': 'Context', 
            'll_success': 'Success', 
            'll_comments': 'Targetted users', 
            'll_admin_issues': 'Administrative issues',
            'll_theme_combined': 'Lessons learned theme(s)',
            'll_theme': 'Lessons learned theme',
            'll_theme_category': 'Lessons learned theme category',

            'gp_context': 'Context',
            'gp_cause': 'Cause/effect', 
            'gp_impact_beneficiaries': 'Impact and beneficiaries',
            'gp_replication': 'Replication', 
            'gp_links': 'Links',
            'gp_theme_combined': 'Good practices theme(s)',
            'gp_theme': 'Good practices theme',
            'gp_theme_category': 'Good practices theme category',
            'gp_document_comments': 'Other documents or comments',

            'rec_response': 'Management response', 
            'rec_action_plan': 'Action plan', 
            'rec_progress': 'Progress', 
            'rec_comments': 'Comments', 
            'rec_info_source': 'Information source', 
            'rec_date': 'Recommendation date',
            'rec_admin_unit': 'Recommendation administrative unit',
            'rec_tc_symbol': 'Recommendation project symbol',
            'rec_theme_combined': 'Recommendation theme',
            'rec_theme_category': 'Recom. theme category',
            'rec_theme': 'Recommendation theme',

            'management_response': 'Management response',

            'doc_title': 'Document(s)',

            'search': 'Search'

        },
        sourceTitles: {
            'eval': 'evaluations',
            'll': 'lessons learned',
            'gp': 'good practices',
            'rec': 'recommendations',
            'planned': 'planned evaluations'
        },
        sourceTitlesLong: {
            'eval': 'Evaluation reports',
            'll': 'Lessons learned',
            'gp': 'Good practices',
            'rec': 'Recommendations & management responses',
            'planned': 'Planned evaluations',
            'ai': 'AI Assistant'
        }
    },
    display: {
        fadeWidth: 60,
        mapOffset: {
            top: 200,
            bottom: 200
        },
        themeColors: {
            // colors for theme categories will be loaded into this config from index.js
            'default': [10, 62, 67],
            'other': [10, 62, 67]
        }
    },
}

config.screens = {};
config.screens.evaluationPart = ['eval_id', 'eval_title', 'region', 'country', 'theme_combined', 
                'eval_type', 'eval_timing', 'eval_nature',
                // below line results in a button and a list of documents, doc_type and doc_id are not displayed
                'doc_type', 'doc_id', 'doc_title',  
                'completion_date',
                'eval_manager', 'administrative_unit', 'tech_unit', 'funding_source', 
                'tc_symbol'];
config.screens.lessonsLearned = ['ll_desc', 'll_context', 'll_success', 'll_challenges', 'll_admin_issues', 'll_comments', 'll_theme_combined']
        // moving theme_combined to the end of the array
        .concat(config.screens.evaluationPart).filter((f) => (f !== 'theme_combined')).concat(['theme_combined']);
config.screens.goodPractices = ['gp_desc', 'gp_context', 'gp_cause', 'gp_impact_beneficiaries', 'gp_replication', 'gp_links', 'gp_theme_combined','gp_document_comments']
        // moving theme_combined to the end of the array
        .concat(config.screens.evaluationPart).filter((f) => (f !== 'theme_combined')).concat(['theme_combined']);
config.screens.recommendations = ['rec_desc', 'rec_response', 'rec_action_plan', 'rec_progress', 'rec_comments', 'rec_info_source', 'rec_date', 'rec_theme_combined']
        // moving theme_combined to the end of the array        
        .concat(config.screens.evaluationPart).filter((f) => (f !== 'theme_combined')).concat(['theme_combined'])
        // for recommendation load tc symbol and theme from the recommendation table
        .map((field) => (['tc_symbol'].includes(field) ? 'rec_' + field : field))
        // for recommendations we get the admin unit form the recommendation table
        .map((field) => (field === 'administrative_unit' ? 'rec_admin_unit' : field));
config.screens.evaluations = config.screens.evaluationPart.concat(['buttons']);

config.imgPath = config.root + 'img/';

export default config;